import {
  // Menu,
  Spin,
} from 'antd';
import React from 'react';
import styled from 'styled-components';
import {
  boxShadow, primaryHeadingColor, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import { SRICompanyPeopleViewGraph } from 'Types/SRITypes';
// import DropdownFilter from './DropdownFilter';
import EmptyState from 'Components/common/components/EmptyState';
import BarChart from './BarChart';

const Wrapper = styled.div`
  .title {
    font-size: 25px;
    font-weight: ${wMBold};
    letter-spacing: -0.7px;
    font-family: ${secondaryFont};
    color: ${primaryHeadingColor};
  }
  .tabs-item {
    cursor: pointer;
  }
  .no-data-holder {
    font-size: 20px;
    height: 250px;
    width: 100%;
    margin: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: ${wMBold};
    letter-spacing: -0.7px;
    font-family: ${secondaryFont};
    color: ${primaryHeadingColor};
  }
`;

const ChartsOverlayStyle = styled.div`
  padding: 24px 42px;
  box-shadow: ${boxShadow};
  border-radius: 16px;
  margin-bottom: 24px;
`;

const LoadingWrapper = styled.div`
  height: auto;
  .ant-spin-spinning {
   margin-top: 2px;
  }
  .chart-overlay-loader{
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;  
  }
`;

// const menu = (
//   <Menu>
//     <Menu.Item>This Month</Menu.Item>
//     <Menu.Item>Last 3 Month</Menu.Item>
//     <Menu.Item>Last 6 Month</Menu.Item>
//     <Menu.Item>Last 12 Month</Menu.Item>
//   </Menu>
// );

type Props = {
  data: SRICompanyPeopleViewGraph
  loading: boolean
};

const ChartsOverlay: React.FC<Props> = function ChartsOverlay(props: Props) {
  const { data, loading } = props;

  const xAxisData = data
    && data.results
    && data?.results.map((result) => result.date);

  const seriesData = data
    && data.results
    && data?.results.map((result) => ({
      y: result.count,
      x: new Date(result.date),
    }));
  return (
    <Wrapper>
      <ChartsOverlayStyle>
        {loading ? (
          <LoadingWrapper>
            <div className="tabs-item chart-overlay-loader">
              <Spin />
            </div>
          </LoadingWrapper>
        )
          : (
            <>
              <div className="head-wrap d-flex justify-content-between mb-c-30">
                <h6 className="title mb-0">{data?.section_name}</h6>
                {/* <DropdownFilter menu={menu} /> */}
              </div>
              {data
                && (
                  <BarChart
                    seriesColor={Object.keys(data).length > 0
                      ? data?.colors.background_color : ''}
                    seriesName={data ? data.section_name : ''}
                    seriesDate={seriesData}
                    xAxis={xAxisData}
                  />
                )}
            </>
          )}
        {data?.results?.length === 0 && !loading && (
          <EmptyState
            msg="No analytics data found"
            detail="Try adjusting your filters to find what you are looking for"
            height="250px"
          />
        )}
      </ChartsOverlayStyle>
    </Wrapper>
  );
};

export default ChartsOverlay;
